/**
 * Einheitliche Anzeige-Labels für Programme und Kategorien: "<nr>_<name>".
 *
 * Die EINZIGE Stelle, die das Format kennt — alle Ansichten (Dashboard,
 * Sidebar, Berechtigungs-Matrix, Owner, Scheduler, …) rendern über diese
 * Helper. Solange ein Programm noch keine Nummer hat (Übergangsphase der
 * Nummern-Einführung), fällt das Label auf den nackten Namen zurück.
 *
 * matchesProgrammeSearch ist das Gegenstück für die Suchfelder: findet über
 * Nummer ("3020"), Name ("glawel") und technische ID ("rechnungspruefung-glawel").
 */

export interface ProgrammeLabelSource {
  name: string;
  programmNr?: number;
}

export interface CategoryLabelSource {
  name: string;
  kategorieNr?: number;
}

export function formatProgrammeLabel(p: ProgrammeLabelSource): string {
  return p.programmNr != null ? `${p.programmNr}_${p.name}` : p.name;
}

export function formatCategoryLabel(c: CategoryLabelSource): string {
  return c.kategorieNr != null ? `${c.kategorieNr}_${c.name}` : c.name;
}

export function matchesProgrammeSearch(
  p: ProgrammeLabelSource & { id?: string },
  query: string,
): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return (
    p.name.toLowerCase().includes(q) ||
    (p.programmNr != null && String(p.programmNr).includes(q)) ||
    (p.id != null && p.id.toLowerCase().includes(q))
  );
}
